import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const BackIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' ref={ref} {...props}>
        <path d='M17.0792 4.69879C17.5859 4.20414 17.5908 3.3908 17.0901 2.89007C16.597 2.39705 15.7989 2.3931 15.301 2.88121L7.09247 10.9288C6.49261 11.5169 6.49261 12.483 7.09247 13.0711L15.301 21.1187C15.7989 21.6068 16.597 21.6028 17.0901 21.1098C17.5908 20.6091 17.5859 19.7958 17.0792 19.3011L9.59994 11.9999L17.0792 4.69879Z' fill='currentColor' />
    </svg>
));
